function initFeaturedSliders() {
  document.querySelectorAll('.index-featured-collection-slider').forEach(el => {
    const isMobile = window.innerWidth < 750;

    if (isMobile) {
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }
      return;
    }

    if (!el.swiper) {
      new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
          forceToAxis: true
        },
        observer: true,
        observeParents: true,
        freeMode: true,
        breakpoints: {
          750: {},
          990: {},
          1200: {},
          1440: {}
        }
      });
    }
  });
}

initFeaturedSliders();

let sliderResizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(sliderResizeTimer);
  sliderResizeTimer = setTimeout(initFeaturedSliders, 200);
});